module.exports = __webpack_public_path__ + "static/media/stepper.82e434ac.svg";